import { useDebounce } from '@react-hook/debounce';
import { useState } from 'react';

export function useThrottledSearchValue(initialState, wait) {
  const [searchValue, setSearchValue] = useDebounce(initialState, wait, false);
  const [searchText, setSearchText] = useState(initialState);
  const setSearch = (value) => {
    setSearchValue(value);
    setSearchText(value);
  };
  return [searchText, searchValue, setSearch];
}
